import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '../Reveal';
import { ArrowMark, Note } from '../Marks';
const BRANCHES = [{
  to: '/catering',
  eyebrow: 'Det vi gör mest',
  title: 'Catering',
  text: 'Till kontoret, festen, konferensen eller bröllopet. Löpande varje vecka eller en enda gång.',
  cta: 'Beställ till ett tillfälle',
  tone: 'lead' as const,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/eb3d836c-650b-45a4-9ab8-2b946d2a1f10.jpg'
}, {
  to: '/guide',
  eyebrow: 'När du är på plats',
  title: 'Guiden',
  text: 'Vart man går i Växjö, Kalmar, Eksjö och Vetlanda. Betyg och beställningstips från oss.',
  cta: 'Se guiden',
  tone: 'quiet' as const,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8303ae1b-9d0f-45da-b556-99c68efa3216.jpg'
}, {
  to: '/butik',
  eyebrow: 'Hem till dörren',
  title: 'Butiken',
  text: 'Dryck, bakverk och skafferi från småländska producenter. Köp direkt, privat eller mot faktura.',
  cta: 'Handla',
  tone: 'quiet' as const,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bfc5d9a0-2049-4a35-b378-fe08b7998bc1.jpg'
}];
export function Branches() {
  return <section aria-labelledby="grenar" className="border-y border-black/12" data-id="element-362" data-mp="5gd6yvcmqo6z">
      <div className="mx-auto max-w-page px-5 py-14 md:px-8 md:py-16" data-id="element-363" data-mp="aeeq1ga22nig">
        <Reveal data-id="element-364" data-mp="y2o9ibjsqz6f">
          <div className="flex flex-wrap items-baseline justify-between gap-4" data-id="element-365" data-mp="y49421642i4a">
            <h2 id="grenar" className="display-xl text-3xl uppercase sm:text-4xl" data-id="element-366" data-mp="132u33x9mmvr5">
              Tre sätt att använda oss
            </h2>
            <Note data-id="element-367" data-mp="o4i4hl2p1cxc">Vi tipsar hela vägen.</Note>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-8 lg:grid-cols-[minmax(0,1.5fr),minmax(0,1fr),minmax(0,1fr)]" data-id="element-368" data-mp="t339dxsw4ks4">
          {BRANCHES.map((branch, i) => <Reveal key={branch.to} delay={Math.min(i * 0.06, 0.18)} data-id="element-369" data-mp="38xlotf7cxo1p" data-mpi={i}>
              <Link to={branch.to} className={`group flex h-full flex-col border-t-2 pt-5 ${branch.tone === 'lead' ? 'border-rod' : 'border-black'}`} data-id="element-370" data-mp="3dvwwbja6jmgr">
                <p className={`text-[11px] font-bold uppercase tracking-wide3 ${branch.tone === 'lead' ? 'text-rod' : 'text-black/45'}`} data-id="element-371" data-mp="1altm41t6el9z">
                  {branch.eyebrow}
                </p>
                <h3 className={`display-xl mt-2 uppercase leading-none ${branch.tone === 'lead' ? 'text-5xl sm:text-7xl' : 'text-4xl sm:text-5xl'}`} data-id="element-372" data-mp="10p6yx6ddni4s">
                  {branch.title}
                </h3>

                <div className={`mt-5 overflow-hidden bg-black/5 ${branch.tone === 'lead' ? 'aspect-[16/9]' : 'aspect-[16/10]'}`} data-id="element-373" data-mp="mp61y208guul">
                  <img src={branch.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-374" data-mp="2h36wiaor2vov" />
                </div>

                <p className={`mt-4 leading-relaxed text-black/70 ${branch.tone === 'lead' ? 'text-lg' : ''}`} data-id="element-375" data-mp="2yciyw44do8c9">
                  {branch.text}
                </p>

                <span className={`mt-auto flex items-center gap-2 pt-5 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out ${branch.tone === 'lead' ? 'text-rod' : 'group-hover:text-rod'}`} data-id="element-376" data-mp="25owxn2imhfsk">
                  {branch.cta}
                  <ArrowMark className="h-4 w-9 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-377" data-mp="3r0ol6vb2y5e7" />
                </span>
              </Link>
            </Reveal>)}
        </div>
      </div>
    </section>;
}